const blockFields = `
  id
  typeHandle
  idName
  backgroundImage {
    url @transform(mode: "crop", width: 1440, height: 558, immediately: true)
    title
  }
  heading
  copy
  additionalCopy
  placeholderInput
  hideDrFinderComponent
`

export const CFindADoctorFragments = {
  field: `
    fragment findADoctor on findADoctor_MatrixField {
      ... on findADoctor_block_Entry {
        ${blockFields}
      }
    }
  `,
  uiField: `
    fragment uiFindADoctor on uiFindADoctor_MatrixField {
      ... on uiFindADoctor_block_Entry {
        ${blockFields}
      }
    }
  `,
}
